const state = {
  MasterGUID: null,
  ProductName: null, //�~�W
  PartNumber: null, //�Ƹ�
  GUInumber: null, //�t�ӱb��(�νs)
  SupplierName: null, //�t�ӦW��
  DemandNumber: null, //�ݨD�渹
  SystemNumber: null, //�t�γ渹
  CreateUser: null,
  CreateDate: null,
  ModifyUser: null,
  ModifyDate: null,
  SignState: null,
  Company: null,
  Range: null, //���νd��
  isEdit: false,
  isShowReport: false,
  Details: [],
  DeleteDetails: [],
  PurchaserType: false, // true => �ѱ��ʶi�J false => �w�]
  RD_SignUser: null, //��o�H��
};
const mutations = {
  SetCompany(state, val) {
    state.Company = val;
  },
  SetRD_SignUser(state, user) {
    state.RD_SignUser = user;
  },

  SetPurchaserType(state, bool) {
    state.PurchaserType = bool;
  },
  SetMasterGUID(state, GUID) {
    state.MasterGUID = GUID;
  },
  SetProductName(state, name) {
    state.ProductName = name;
  },
  SetGUInumber(state, num) {
    state.GUInumber = num;
  },
  SetSignState(state, num) {
    state.SignState = num;
  },
  SetSupplierName(state, name) {
    state.SupplierName = name;
  },
  SetDemandNumber(state, num) {
    state.DemandNumber = num;
  },
  SetSystemNumber(state, num) {
    state.SystemNumber = num;
  },
  SetCreateUser(state, user) {
    state.CreateUser = user;
  },
  SetCreateDate(state, date) {
    state.CreateDate = date;
  },
  SetModifyUser(state, user) {
    state.ModifyUser = user;
  },
  SetModifyDate(state, date) {
    state.ModifyDate = date;
  },
  SetDetails(state, item) {
    state.Details = item;
  },
  SetDeleteDetails(state, item) {
    state.DeleteDetails = item;
  },
  SetisEdit(state, bool) {
    state.isEdit = bool;
  },
  SetisShowReport(state, bool) {
    state.isShowReport = bool;
  },
  SetRange(state, val) {
    state.Range = val;
  },
};
const actions = {
  SetisEdit(context, bool) {
    context.commit("SetisEdit", bool);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
